import React from 'react';

interface BusinessLogoProps {
  logo: string;
  businessName: string;
}

const BusinessLogo: React.FC<BusinessLogoProps> = ({ logo, businessName }) => {
  return (
    <div className='bg-white rounded-xl p-6 shadow-sm min-w-full' style={{'border': '1px solid #0000001A'}}>
      <h2 className='text-lg font-semibold text-gray-900 mb-4'>Business Logo</h2>
      <div className='aspect-square rounded-lg overflow-hidden'>
        <img
          src={logo}
          alt={`${businessName} logo`}
          className='w-full h-full object-cover'
        />
      </div>
    </div>
  );
};

export default BusinessLogo;


export const BusinessLogoo: React.FC<BusinessLogoProps> = ({ logo, businessName }) => {
  return (
    <div className='bg-white rounded-xl p-6 shadow-sm w-[30%] h-full overflow-hidden' style={{'border': '1px solid #0000001A'}}>
      <h2 className='text-lg font-semibold text-gray-900 mb-4'>Business Logo</h2>
      <div className='w-full h-full rounded-lg overflow-hidden flex items-center justify-center'>
        <img
          src={logo}
          alt={`${businessName} logo`}
          className='w-[80%] h-[80%] object-cover overflow-hidden'
        />
      </div>
    </div>
  );
};
